import api from 'api';
import { httpErrorTypes } from 'utility/error';
import { sessionUser } from 'utility/sessionStorageHelper';
import i18n from 'i18n';
export const PENDING_ACTIONS_DM_REQUEST = 'PENDING_ACTIONS_DM_REQUEST';
export const PENDING_ACTIONS_DM_SUCCESS = 'PENDING_ACTIONS_DM_SUCCESS';
export const PENDING_ACTIONS_DM_FAILURE = 'PENDING_ACTIONS_DM_FAILURE';
export const PENDING_ACTIONS_CIRA_REQUEST = 'PENDING_ACTIONS_CIRA_REQUEST';
export const PENDING_ACTIONS_CIRA_SUCCESS = 'PENDING_ACTIONS_CIRA_SUCCESS';
export const PENDING_ACTIONS_CIRA_FAILURE = 'PENDING_ACTIONS_CIRA_FAILURE';
export const PENDING_ACTIONS_TIRA_REQUEST = 'PENDING_ACTIONS_TIRA_REQUEST';
export const PENDING_ACTIONS_TIRA_SUCCESS = 'PENDING_ACTIONS_TIRA_SUCCESS';
export const PENDING_ACTIONS_TIRA_FAILURE = 'PENDING_ACTIONS_TIRA_FAILURE';
export const PENDING_ACTIONS_TATM_REQUEST = 'PENDING_ACTIONS_TATM_REQUEST';
export const PENDING_ACTIONS_TATM_SUCCESS = 'PENDING_ACTIONS_TATM_SUCCESS';
export const PENDING_ACTIONS_TATM_FAILURE = 'PENDING_ACTIONS_TATM_FAILURE';
export const PENDING_ACTIONS_ENTITY_REQUEST = 'PENDING_ACTIONS_ENTITY_REQUEST';
export const PENDING_ACTIONS_ENTITY_SUCCESS = 'PENDING_ACTIONS_ENTITY_SUCCESS';
export const PENDING_ACTIONS_ENTITY_FAILURE = 'PENDING_ACTIONS_ENTITY_FAILURE';
export const PENDING_ACTIONS_HCEOB_REQUEST = 'PENDING_ACTIONS_HCEOB_REQUEST';
export const PENDING_ACTIONS_HCEOB_SUCCESS = 'PENDING_ACTIONS_HCEOB_SUCCESS';
export const PENDING_ACTIONS_HCEOB_FAILURE = 'PENDING_ACTIONS_HCEOB_FAILURE';
export const DASHBOARD_FILTER_REQUEST = 'DASHBOARD_FILTER_REQUEST';
export const DASHBOARD_FILTER_SUCCESS = 'DASHBOARD_FILTER_SUCCESS';
export const DASHBOARD_FILTER_FAILURE = 'DASHBOARD_FILTER_FAILURE';
export const ENTITIES_REQUEST = 'ENTITIES_REQUEST';
export const ENTITIES_SUCCESS = 'ENTITIES_SUCCESS';
export const ENTITIES_FAILURE = 'ENTITIES_FAILURE';
export const EXPORT_REQUEST = 'EXPORT_REQUEST';
export const EXPORT_SUCCESS = 'EXPORT_SUCCESS';
export const EXPORT_FAILURE = 'EXPORT_FAILURE';
export const REPORTS_REQUEST = 'REPORTS_REQUEST';
export const REPORTS_SUCCESS = 'REPORTS_SUCCESS';
export const REPORTS_FAILURE = 'REPORTS_FAILURE';
export const TRANSACTION_DATA_REQUEST = 'TRANSACTION_DATA_REQUEST';
export const TRANSACTION_DATA_SUCCESS = 'TRANSACTION_DATA_SUCCESS';
export const TRANSACTION_DATA_FAILURE = 'TRANSACTION_DATA_FAILURE';
export const RESET_DASHBOARD_DATA = 'RESET_DASHBOARD_DATA';

import { handleDownloadFile } from 'utility/downloadUtility';

export const dashboardURL = endpoint => {
  const { customerId, userId } = sessionUser.getLoggedInUser().getId();
  return `insightsdashboardsvc/v0/cust/${customerId}/user/${userId}/` + endpoint;
};

export const resetDashboardData = () => ({
  type: RESET_DASHBOARD_DATA
});

export const getPendingActionsDM = () => {
  return {
    types: [PENDING_ACTIONS_DM_REQUEST, PENDING_ACTIONS_DM_SUCCESS, PENDING_ACTIONS_DM_FAILURE],
    callAPI: (state, options) => api.fetch(dashboardURL(`pendingActions/decisionItems`)),
    httpErrorTypes
  };
};

export const getPendingActionsCIRA = () => {
  return {
    types: [PENDING_ACTIONS_CIRA_REQUEST, PENDING_ACTIONS_CIRA_SUCCESS, PENDING_ACTIONS_CIRA_FAILURE],
    callAPI: (state, options) => api.fetch(dashboardURL(`pendingActions/cira`)),
    httpErrorTypes
  };
};

export const getPendingActionsTIRA = () => {
  return {
    types: [PENDING_ACTIONS_TIRA_REQUEST, PENDING_ACTIONS_TIRA_SUCCESS, PENDING_ACTIONS_TIRA_FAILURE],
    callAPI: (state, options) => api.fetch(dashboardURL(`pendingActions/tira`)),
    httpErrorTypes
  };
};

export const getPendingActionsTATM = () => {
  return {
    types: [PENDING_ACTIONS_TATM_REQUEST, PENDING_ACTIONS_TATM_SUCCESS, PENDING_ACTIONS_TATM_FAILURE],
    callAPI: (state, options) => api.fetch(dashboardURL(`pendingActions/tatm`)),
    httpErrorTypes
  };
};

export const getPendingActionsEntity = () => {
  return {
    types: [PENDING_ACTIONS_ENTITY_REQUEST, PENDING_ACTIONS_ENTITY_SUCCESS, PENDING_ACTIONS_ENTITY_FAILURE],
    callAPI: (state, options) => api.fetch(dashboardURL(`pendingActions/entityItems`)),
    httpErrorTypes
  };
};

export const getPendingActionsHCEOB = () => {
  return {
    types: [PENDING_ACTIONS_HCEOB_REQUEST, PENDING_ACTIONS_HCEOB_SUCCESS, PENDING_ACTIONS_HCEOB_FAILURE],
    callAPI: (state, options) => api.fetch(dashboardURL(`pendingActions/hceobItems`)),
    httpErrorTypes
  };
};

export const getFilterFields = () => {
  return {
    types: [DASHBOARD_FILTER_REQUEST, DASHBOARD_FILTER_SUCCESS, DASHBOARD_FILTER_FAILURE],
    callAPI: (state, options) => api.fetch(dashboardURL(`dashboard-filters`)),
    httpErrorTypes
  };
};

export const getTransactionData = payload => {
  return {
    types: [TRANSACTION_DATA_REQUEST, TRANSACTION_DATA_SUCCESS, TRANSACTION_DATA_FAILURE],
    callAPI: (state, options) => api.save(dashboardURL(`insight-dashboard/transaction-data`), payload),
    httpErrorTypes
  };
};

export const getTopEntities = payload => {
  return {
    types: [ENTITIES_REQUEST, ENTITIES_SUCCESS, ENTITIES_FAILURE],
    callAPI: (state, options) => api.save(dashboardURL(`insight-dashboard/entities-data`), payload),
    httpErrorTypes
  };
};

const downloadExport = () => (dispatch, getState) => {
  const state = getState();
  const exportResult = state.dashboard.pdfData;
  if (!exportResult) {
    return;
  }
  const filename = `insights_dashboard_${new Date().getTime()}.pdf`;
  handleDownloadFile(exportResult, filename, 'application/pdf');
};

export const getExportPdf = payload => {
  return {
    types: [EXPORT_REQUEST, EXPORT_SUCCESS, EXPORT_FAILURE],
    callAPI: (state, options) => api.fetchPdf(dashboardURL(`insight-dashboard/export-pdf`), payload),
    dispatchOnSuccess: [() => downloadExport()],
    httpErrorTypes,
    errorDisplayType: 'modal',
    errorTitle: i18n.t('dashboard.export.errors.title')
  };
};
export const getReports = () => {
  return {
    types: [REPORTS_REQUEST, REPORTS_SUCCESS, REPORTS_FAILURE],
    callAPI: (state, options) => api.fetch(dashboardURL(`latest-custom-reports`)),
    httpErrorTypes
  };
};
